import React, { useState } from 'react';
import './DeleteButton.scss';
import Button, { ButtonSize, ButtonType } from './Button';

type DeleteButtonProps = {
  isLoading: boolean;
  className?: string;
  onClick: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  message?: string | null;
  type?: ButtonType;
  size?: ButtonSize;
  'aria-label'?: string;
  title?: string;
};

const DeleteButton: React.FC<DeleteButtonProps> = ({
  isLoading,
  onClick,
  children,
  disabled,
  className,
  message,
  type,
  size,
  'aria-label': ariaLabel,
  title
}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleDelete = () => {
    onClick();
    setShowConfirm(false);
  };

  return (
    <>
      <Button
        type={type}
        size={size}
        isLoading={isLoading}
        onClick={() => setShowConfirm(true)}
        className={`${className} delete`}
        disabled={disabled}
        isSubmit={false}
        aria-label={ariaLabel}
        title={title}
      >
        {children}
      </Button>

      {showConfirm && (
        <div className="confirm-overlay">
          <div className="confirm-box">
            <p>{message ?? 'Are you sure you want to delete?'}</p>
            <div className="button-container">
              <Button
                isLoading={isLoading}
                onClick={handleDelete}
                className="confirm-button"
                disabled={false}
                isSubmit={false}
              >
                Yes
              </Button>
              <Button type="Outline" onClick={() => setShowConfirm(false)}>
                No
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeleteButton;
